"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "malvicino": {
    "6c2ac1ad": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "alberghina": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba58278b": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "bric-della-vite": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3da99f7": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "fonda": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d6556e2": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "gelati": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2a2e799": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "gramonda": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c29c8b0": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "isola-buona": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8364e975": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "laiazzo": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44bd647c": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "marelli": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3dc54fc3": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "pian-gallina": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cea86307": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "prazzini": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "055f92bc": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "pronetto": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a01d2d9": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "redimunce": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71ece66f": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "skipSearch": false
    }],
    "saliceto": [{
      "hkey": "c03c6ff3",
      "slug": "malvicino",
      "name": "Malvicino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;